export const ROLE_LABELS = {
  admin: '⚡ Admin',
  both: '⚡ Admin + Utilisateur',
  responsable: '🔑 Responsable',
  user: '👤 Utilisateur',
};

const MANAGEMENT_FIELDS = [
  'manage_planning',
  'manage_objectives',
  'manage_kpi',
  'mobile_full_access',
];

export function defaultPermissions(role) {
  if (role === 'admin' || role === 'both') {
    return {
      visible_planning: 0,
      view_planning: 1,
      view_chiffres: 1,
      view_dluo: 1,
      view_stocks: 1,
      manage_planning: 1,
      manage_objectives: 1,
      manage_kpi: 1,
      mobile_full_access: 1,
    };
  }

  return {
    visible_planning: 1,
    view_planning: 1,
    view_chiffres: 0,
    view_dluo: 0,
    view_stocks: 0,
    manage_planning: 0,
    manage_objectives: 0,
    manage_kpi: 0,
    mobile_full_access: 0,
  };
}

export function permissionsAfterRoleChange(permissions, storeIds, newRole) {
  const nextPermissions = {};

  storeIds.forEach(storeId => {
    const current = permissions[storeId];
    const next = current ? { ...current } : defaultPermissions(newRole);

    if (newRole === 'user') {
      MANAGEMENT_FIELDS.forEach(field => { next[field] = 0; });
    }

    nextPermissions[storeId] = next;
  });

  return nextPermissions;
}
